module.exports = __webpack_public_path__ + "static/storyline-5676302e8b3d8c81e198771fe48f5219.png";